import z from 'zod';

export type FileModel = {
	fileId: string;
	uploadedAt: string;
	status: "done" | "processing" | "failed" | "error" | "source" | "validate";
	username: string;
	dateStart: string;
	dateEnd: string;
	groupName: string;
};

export const FileModelSchema: z.ZodType<FileModel> = z.object({
	fileId: z.string(),
	uploadedAt: z.string(),
	status: z.enum(["done", "processing", "validate", "failed", "error", "source"]),
	username: z.string(),
	dateStart: z.string(),
	dateEnd: z.string(),
	groupName: z.string(),
});
